import { Tooltip as MuiTooltip, type TooltipProps as MuiTooltipProps } from "@material-ui/core";
import { Css, px } from "src/Css";

export function Tooltip(props: MuiTooltipProps) {
  const tooltipClassName = props.classes?.tooltip
    ? `${tooltipClassNames.tooltip} ${props.classes.tooltip}`
    : tooltipClassNames.tooltip;

  return <MuiTooltip {...props} classes={{ ...props.classes, tooltip: tooltipClassName }} />;
}

export function TooltipV2(props: MuiTooltipProps) {
  const tooltipClassName = props.classes?.tooltip
    ? `${tooltipV2ClassNames.tooltip} ${props.classes.tooltip}`
    : tooltipV2ClassNames.tooltip;

  return <MuiTooltip {...props} classes={{ ...props.classes, tooltip: tooltipClassName }} />;
}

const tooltipClassNames = {
  tooltip: Css.props(Css.bgBlueBright.maxw(px(200)).p2.shadowHover.br3.t14.white.$).className as string,
};

const tooltipV2ClassNames = {
  tooltip: Css.props(
    Css.bgBlack.maxw(px(450)).px1.pyPx(4).shadowHover.br3.f12.whitePure.add("letterSpacing", "unset").$,
  ).className as string,
};
